import type {
    BoundingBox} from "./bounding-box";
import {
    boundingBoxForBoundingBox,
    correctionAngleForBoundingBox,
    vert3OffsetsForBoundingBox,
} from "./bounding-box";

export interface BoundingBoxRotationResult {
    imageData: ImageData;
    correctionAngle: number;
    sourceXOffset: number;
    sourceYOffset: number;
    xv3Offset: number;
    yv3Offset: number;
}

export function rotateBoundingBoxViaCanvas(
    srcCtx: CanvasRenderingContext2D,
    procCtx: CanvasRenderingContext2D,
    boundingBox: BoundingBox,
    outputPadding: number
): BoundingBoxRotationResult {
    const { width: boxWidth, height: boxHeight } = boundingBox;
    const correctionAngle = correctionAngleForBoundingBox(boundingBox);

    const sourceLocation = boundingBoxForBoundingBox(boundingBox, outputPadding, outputPadding);
    const { vertex3: sourceOffset, width: sourceWidth, height: sourceHeight } = sourceLocation;

    const { canvas: procCanvas } = procCtx;
    procCanvas.width = boxWidth + 2 * outputPadding;
    procCanvas.height = boxHeight + 2 * outputPadding;

    const v3PadOffsets = vert3OffsetsForBoundingBox(boundingBox, outputPadding, outputPadding);

    const xv3Offset = v3PadOffsets[0] - sourceOffset[0];
    const yv3Offset = v3PadOffsets[1] - sourceOffset[1];

    procCtx.rotate(correctionAngle);
    procCtx.translate(-xv3Offset, -yv3Offset);
    procCtx.drawImage(
        srcCtx.canvas,
        sourceOffset[0],
        sourceOffset[1],
        sourceWidth,
        sourceHeight,
        0,
        0,
        sourceWidth,
        sourceHeight
    );
    procCtx.resetTransform();

    const imageData = procCtx.getImageData(0, 0, procCanvas.width, procCanvas.height);
    return {
        imageData,
        correctionAngle,
        xv3Offset,
        yv3Offset,
        sourceXOffset: sourceOffset[0],
        sourceYOffset: sourceOffset[1],
    };
}
